import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import { ApolloConsumer } from "@apollo/client";
import * as widgets from "widgets/register";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = (props) => (
  <ApolloConsumer>
    {(client) => <ContentHandler {...props} client={client} />}
  </ApolloConsumer>
);

const ContentHandler = ({
  match: {
    params
  },
}) => {
  const { values, schema, base } = useSectionContext();
  return (
    <>
      <Container className="mt-4">
        <Row>
          <Col>
            <div className="float-right">
              <Link className="btn btn-primary" to={`${base}/edit`}>
                Edit
              </Link>{" "}
              <Link className="btn btn-danger" to={`${base}/remove`}>
                Remove
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Fields
              schema={schema}
              values={values}
              widgets={widgets}
              target={{ $ref: "/Public/PointLimit" }}
              config={{
                "/Public/PointLimit": {
                  fields: ["description", "dimensions", "limits"],
                },
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};
